// Stride governance voted to wind down the chain. The v35 upgrade (prop #286) removed the
// liquid stake and redeem messages on-chain, so the app can no longer submit either.
// Hardcoded on purpose: the Upstash announcement banner was hijacked once (#859), and this
// message must not be overridable from Redis.

interface WindDownRedemption {
  denom: string
  // Set once the stToken's Osmosis transmuter pool is funded and announced; the UI switches to a link.
  poolUrl: string | null
}

const WIND_DOWN = {
  isLiquidStakingDisabled: true,
  proposalUrl: 'https://www.mintscan.io/stride/proposals/286',
  discussionUrl: 'https://common.xyz/stride/discussion/1313365-Orderly%20wind%20down%20of%20Stride%20chain',
  releaseNotesUrl: 'https://github.com/Stride-Labs/stride/releases/tag/v35.0.0',
  // Public-facing date for pools opening and the chain halting. Some pools open earlier.
  targetDate: 'Nov 20, 2026',
  redemptions: [
    { denom: 'ATOM', poolUrl: null },
    { denom: 'TIA', poolUrl: null },
    { denom: 'OSMO', poolUrl: null },
    { denom: 'DYDX', poolUrl: null },
    { denom: 'INJ', poolUrl: null },
    { denom: 'LUNA', poolUrl: null },
    { denom: 'SAGA', poolUrl: null },
    { denom: 'JUNO', poolUrl: null },
    { denom: 'SOMM', poolUrl: null },
    { denom: 'ISLM', poolUrl: null },
    { denom: 'BAND', poolUrl: null }
  ] as WindDownRedemption[]
}

export { WIND_DOWN }
export type { WindDownRedemption }
